import { render, staticRenderFns } from "./adjust-image-toolbox.vue?vue&type=template&id=9d36a8ce&"
import script from "./adjust-image-toolbox.vue?vue&type=script&lang=ts&"
export * from "./adjust-image-toolbox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports